import * as React from 'react';

import './AccordionSection.scss';

interface IAccordionSectionProps {
  children: any;
  isOpen: boolean;
  identifier: string;
  header: any;
  onClick: (label: string) => void;
}

class AccordionSection extends React.Component<IAccordionSectionProps, any> {
  private handleClick = () => {
    this.props.onClick(this.props.identifier);
  };

  public render() {
    return (
      <table className="tbl-main-header" style={{ width: '100%' }}>
        <tr onClick={this.handleClick}
        onKeyDown={(event:any) => {   	
          if(event.keyCode === 13) {    
            this.handleClick();    
          }       
        }}
        
        >
          {this.props.header}
          <td className="arrow-class" role="button" tabIndex={0}>
            {!this.props.isOpen && <span className="rpds-expand-more" />}
            {this.props.isOpen && <span className="rpds-expand-less" />}
          </td>
        </tr>
        <tr className="rp-accordion-section--expandable">
          {this.props.isOpen && <td colSpan={7}>{this.props.children}</td>}
        </tr>
      </table>
    );
  }
}

export default AccordionSection;
